import styled, { css } from 'styled-components';

import { CommonAction, extCommonAction, recipesCommonAction, styledReset, styledTypography } from '@pkg/primitives';

import { tokens } from './GuestDrawer.tokens';

const actionBase = css`
    padding-left: ${tokens.action.padding}px;
    padding-right: ${tokens.action.padding}px;
    height: ${tokens.action.height}px;
`;

export const TextLinkList = styled.ul`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.link.gap}px;
`;

export const TextLinkItem = styled.li``;

export const TextLink = styled(CommonAction)`
    ${recipesCommonAction.link};
    font-size: ${tokens.link.fontSize}px;
    font-weight: 700;

    &:hover {
        text-decoration-color: rgb(255, 255, 255, 1) !important;
    }

    &:active {
        opacity: 0.8;
    }
`;

///
/// Content

export const Content = styled.div`
    display: grid;
    gap: ${tokens.content.gap}px;
`;

export const Title = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.content.titleSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const Subtitle = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.content.subtitleSize}px;
    line-height: 1.2;
    color: rgb(255, 255, 255, 0.6);
`;

///
/// Actions

export const ActionsGroup = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: ${tokens.action.gap}px;
`;

export const SecondaryAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    ${actionBase};
    background-color: rgb(255, 255, 255, 0.1);

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.16);
    }
`;

export const PrimaryLink = styled(CommonAction)`
    ${recipesCommonAction.primary};
    ${extCommonAction.afterGlowPrimary};
    ${actionBase};
`;

export const ActionLabel = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.action.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;
